import { keyframes, css } from "styled-components";

const whiteDivOpa1 = keyframes`
0%{
  animation-timing-function: cubic-bezier(0,0,.2,1);
  opacity: 0;
   }
33%{
  animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
   opacity: 0.5;
  }
100%{
   opacity:0;
} 
`;

export const whiteDivOpa = css`
  ${whiteDivOpa1} 0.33s 1 forwards
`;

const svgAnimOnAnim = keyframes`
  0%{
    stroke-dashoffset: 43;
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(47deg);
  }
  40% {
    transform: rotate(-3deg);
  }
  60% {
    transform: rotate(22deg);
  }
  80% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
    stroke-dashoffset: 0;
  }
 
`;

export const svgAnimOn = css`
  ${svgAnimOnAnim} 500ms 1 forwards linear
`;
const scaleAnimFooterBtn = keyframes`
0%{  
  animation-timing-function: cubic-bezier(.33,1,0,1);
  transform: scale(1);
  }
50%{
  animation-timing-function: cubic-bezier(0,0,0,1);
  transform: scale(.65);

 }
100%{
  transform: scale(1); 
  } 
`;
export const animFooterBtn = css`
  ${scaleAnimFooterBtn} 0.33s 1 forwards
`;
